import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/license.products.query.gql"
import type {
  LicenseProductsQuery,
  LicenseProductsQueryVariables,
} from "@/v2-backoffice-client/license/__types__/license.products.query"

type Options = QueryHookOptions<
  LicenseProductsQuery,
  LicenseProductsQueryVariables
>

export function useLicenseProductsQuery(options?: Options) {
  return useQuery<LicenseProductsQuery, LicenseProductsQueryVariables>(
    query,
    options,
  )
}
